import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    height: 40,
    padding: '0 18px',
    borderTop: '1px solid var(--hone-portal-hairline-soft)',
    background: 'var(--hone-portal-fill-row-hover)',
  },
  hints: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  hint: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 11.5,
    color: 'var(--bui-fg-secondary)',
  },
  key: {
    fontFamily: 'var(--bui-font-monospace)',
    fontSize: 10,
    lineHeight: '14px',
    color: 'var(--bui-fg-secondary)',
    background: 'var(--hone-portal-fill-inset)',
    border: '1px solid var(--bui-border-1)',
    borderRadius: 4,
    padding: '0 5px',
  },
  spacer: { flex: 1 },
  scope: {
    fontFamily: 'var(--bui-font-monospace)',
    fontSize: 10.5,
    color: 'var(--hone-portal-fg-tertiary)',
  },
});

const HINTS = [
  { keys: '↑↓', label: 'navigate' },
  { keys: '↵', label: 'open' },
  { keys: '⇥', label: 'next group' },
];

export function SearchPaletteFooter() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.hints}>
        {HINTS.map(hint => (
          <span key={hint.label} className={classes.hint}>
            <span className={classes.key}>{hint.keys}</span>
            {hint.label}
          </span>
        ))}
      </span>
      <span className={classes.spacer} />
      {/* Names what the palette actually searches, so an absent result reads as
          out of scope rather than missing. */}
      <span className={classes.scope}>catalog + docs + actions</span>
    </div>
  );
}
